export default __webpack_public_path__ + "static/callout-tubes-mobile-d42648be4b55a946b23498321d90515b.png";